module.exports = __webpack_public_path__ + "img/corriente_c_gray.ca0d66fd.svg";